import React from "react";
import { object, array, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import Row1 from "./Row1";
import Row2 from "./Row2";
import Column from "./Column";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import DfpAd from "../../dfp-ad";

import { getSlug, getCollectionName } from "../../utils/utils";

import "./fourteenStories2AdBigFact.m.css";

const FourteenStories2AdBigFact = ({ collection, sections, domainSlug, lang }) => {
  const stories =
    collection.items && collection.items.length > 0 && collection.items.filter((item) => item.type === "story");

  if (!stories.length) {
    return null;
  }

  const row1Stories = stories.length > 0 && stories.slice(0, 1);
  const columnStories = stories.length > 10 && stories.slice(10, 15);
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");
  const adSlotId1 = get(collection, ["associated-metadata", "ad_slot_id1"], "default_ad_slot1");
  const adSlotId2 = get(collection, ["associated-metadata", "ad_slot_id2"], "default_ad_slot2");
  const adSlotId3 = get(collection, ["associated-metadata", "ad_slot_id3"], "default_ad_slot3");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);

  return stories.length > 1 ? (
    <div styleName="base" className="fourteen-stories-3ad-1widget">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionSlug={collectionSlug} collectionName={collectionName} />
      )}
      <div styleName="wrapper">
        <div>
          {row1Stories.length > 0 && (
            <Row1 stories={row1Stories} collectionSlug={collectionSlug} lang={lang} adSlotId={adSlotId1} />
          )}
          {stories.length > 2 && (
            <Row2 stories={global.deviceWidth > 1263 ? stories.slice(1, 10) : stories.slice(1, 13)} />
          )}
        </div>
        {global.deviceWidth >= 1264 && (
          <Column stories={columnStories} collectionSlug={collectionSlug} lang={lang} adSlotId={adSlotId2} />
        )}
      </div>
      <div styleName="ad-slot">
        <DfpAd
          adtype={lang === "en" ? "EnPalo_HP_468x60_B1" : "Home_468x60_B1"}
          collectionSlug={collectionSlug}
          layoutName="FourteenStories2AdBigFact"
          slotId={adSlotId3}
        />
      </div>
    </div>
  ) : null;
};

FourteenStories2AdBigFact.propTypes = {
  collection: object.isRequired,
  sections: array,
  domainSlug: string,
  lang: string,
};

FourteenStories2AdBigFact.storyLimit = 12;

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(FourteenStories2AdBigFact);
